const authRedirectKey = 'whynotlog.auth.redirect';

export const rememberAuthRedirect = (redirect: string | null) => {
  if (!redirect) {
    return;
  }
  window.sessionStorage.setItem(authRedirectKey, redirect);
};

export const getRememberedAuthRedirect = (): string | null => {
  return window.sessionStorage.getItem(authRedirectKey);
};

export const clearRememberedAuthRedirect = () => {
  window.sessionStorage.removeItem(authRedirectKey);
};
